import { Opcion } from '../../../models/catalogo.type'
import * as yup from 'yup'
import { AppConstantes } from '../../../utils/Constantes'

export const style = {
  borderRadius: '10px',
  background: '#333',
  color: '#fff',
  fontSize: '18px',
}
export type TRecordatorioForm = {
  idRecordatorio: string
  tipo: string
  descTipo: string
  unidad?: Opcion 
  cantidad?: number | null
  fechaRecordatorio?: string | null
  fechaReferencia?: string | null
}

/**
 * Valida recordatorios comunes para autorizaciones, condicionantes y tareas.
 * Si la unidad es personalizada se exige fecha exacta; en cualquier otra unidad
 * se exige cantidad numerica positiva con maximo de cuatro digitos.
 */
export const schemaRecordatorios = yup.object({
  recordatorios: yup.array().of(
    yup.object().shape({
      unidad: yup.object().nullable().required('La unidad del periodo de tiempo es requerida'),
      cantidad: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .when(['unidad'], {
          is: (unidad: Opcion) => {
            return unidad && unidad.valor !== AppConstantes.CVE_UNIDAD_RECORDATORIO_PERSONALIZADO
          },
          then: yup
            .number()
            .required('Cantidad del periodo de tiempo es requerida')
            .typeError('La cantidad del periodo de tiempo requiere de un número')
            .min(1, 'La cantidad debe ser mayor a 0')
            .max(9999, 'Máximo 4 dígitos'),
        }),
      fechaRecordatorio: yup
        .string()
        .nullable()
        .when(['unidad'], {
          is: (unidad: Opcion) => {
            return unidad && unidad.valor === AppConstantes.CVE_UNIDAD_RECORDATORIO_PERSONALIZADO
          },
          then: yup.string().nullable().default(null).required('Una fecha es requerida'),
        }),
    })
  ),
})
